import {
    type MetricField,
    type MyLensesOrganicStatsResponseEntry,
    type OrganicStat,
    UserDimension,
} from "../../../gql-generated/types";
import { ejectAudienceStats } from "../../filters";

export const mapAudienceMetrics = (
    responseEntryList: readonly MyLensesOrganicStatsResponseEntry[],
    baseMetricField: MetricField,
): {
    ageStats: readonly OrganicStat[];
    countryStats: readonly OrganicStat[];
    interestStats: readonly OrganicStat[];
    osStats: readonly OrganicStat[];
} => {
    const [responseEntry] = responseEntryList;

    if (!responseEntry) {
        return {
            ageStats: [],
            countryStats: [],
            interestStats: [],
            osStats: [],
        };
    }

    const statsList = responseEntry.statsResponseTimeEntryList[0]?.statsList.filter(
        ({ field }) => field?.fieldName === baseMetricField,
    );

    return {
        ageStats: ejectAudienceStats(statsList, UserDimension.AgeGender) ?? [],
        countryStats: ejectAudienceStats(statsList, UserDimension.Country) ?? [],
        interestStats: ejectAudienceStats(statsList, UserDimension.InterestCategoryId) ?? [],
        osStats: ejectAudienceStats(statsList, UserDimension.Os) ?? [],
    };
};
